import React from 'react';
import {
  ClonePaymentConnectorApollo,
  SalePaymentGetByTokenConnectorApollo,
  SalePaymentSaveConnectorApollo,
  ShippingOptionsConnectorApollo,
  MakePaymentConnectorApollo,
  getExpiringLocalStorage,
} from '@front-activerse/common-components';
import { useParams } from 'react-router-dom';
import PaymentMethodsContainer from './PaymentMethodsContainer';

interface IPaymentMethodsPage {
  pathThankYou: string;
  pathPaymentMethods: string;
  disableCodOption?: boolean;
}

const PaymentMethodsPage: React.FC<IPaymentMethodsPage> = ({
  pathThankYou,
  pathPaymentMethods,
  disableCodOption = false,
}) => {
  const { token } = useParams();

  if (token) {
    localStorage.setItem('shoppingCartToken', String(token));
  }

  // Reload page on back button
  window.onpageshow = function (event) {
    if (event.persisted) {
      window.location.reload();
    }
  };

  return (
    <div>
      {token && (
        <ShippingOptionsConnectorApollo>
          {({ ...shippingOptions }) => (
            <ClonePaymentConnectorApollo
              token={token}
              source={getExpiringLocalStorage('saleSource')}
            >
              {({ clonePayment }) => (
                <SalePaymentGetByTokenConnectorApollo
                  token={token}
                  clonePayment={clonePayment}
                  pathPaymentMethods={pathPaymentMethods}
                >
                  {({ ...paymentProduct }) => {
                    return (
                      <SalePaymentSaveConnectorApollo>
                        {({ savePayment }) => (
                          <MakePaymentConnectorApollo>
                            {({ makePayment }) => (
                              <PaymentMethodsContainer
                                {...paymentProduct}
                                {...shippingOptions}
                                loading={
                                  paymentProduct.loading ||
                                  shippingOptions.loading ||
                                  !paymentProduct.paymentMethods
                                }
                                shoppingCartToken={token}
                                pathThankYou={pathThankYou}
                                pathPaymentMethods={pathPaymentMethods}
                                savePayment={savePayment}
                                makePayment={makePayment}
                                disableCodOption={disableCodOption}
                              />
                            )}
                          </MakePaymentConnectorApollo>
                        )}
                      </SalePaymentSaveConnectorApollo>
                    );
                  }}
                </SalePaymentGetByTokenConnectorApollo>
              )}
            </ClonePaymentConnectorApollo>
          )}
        </ShippingOptionsConnectorApollo>
      )}
    </div>
  );
};

export default PaymentMethodsPage;
